export default {
  'pages.layouts.userLayout.title':
    'A lightweight, flexible, elegant and full-featured RBAC scaffolding based on GIN + GORM 2.0 + Casbin 2.0 + Wire DI.',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.captcha.placeholder': 'Captcha',
  'pages.login.captcha.required': 'Please input captcha!',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  // welcome
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'A more concise, efficient, and modular golang admin service has been released.',
  'pages.welcome.quickStart': 'Quick Start',
  'pages.welcome.generate': 'Generate Struct',
  'pages.welcome.remove': 'Remove Struct',
  // menu
  'pages.system.menu.add': 'Add Menu',
  'pages.system.menu.edit': 'Edit Menu',
  'pages.system.menu.delTip': 'Are you sure you want to delete this menu and its submenus?',
  'pages.system.menu.button.addChild': 'Add Submenu',
  'pages.system.menu.form.code': 'Code',
  'pages.system.menu.form.code.placeholder': 'Please enter the code',
  'pages.system.menu.form.code.required': 'Code is required!',
  'pages.system.menu.form.name': 'Name',
  'pages.system.menu.form.name.placeholder': 'Please enter the name',
  'pages.system.menu.form.name.required': 'Name is required!',
  'pages.system.menu.form.path': 'Path',
  'pages.system.menu.form.sequence': 'Sequence',
  'pages.system.menu.form.type': 'Type',
  'pages.system.menu.form.type.page': 'Menu',
  'pages.system.menu.form.type.button': 'Button',
  'pages.system.menu.form.status': 'Status',
  'pages.system.menu.form.status.enabled': 'Enabled',
  'pages.system.menu.form.status.disabled': 'Disabled',
  'pages.system.menu.form.description': 'Description',
  'pages.system.menu.form.properties': 'Properties',
  'pages.system.menu.form.parent_name': 'Parent',
  'pages.system.menu.form.created_at': 'Created At',
  'pages.system.menu.form.updated_at': 'Updated At',
  'pages.system.menu.resource.form.basic': 'Basic Information',
  'pages.system.menu.resource.form.title': 'API Resource Configuration',
  'pages.system.menu.resource.form.method': 'Method',
  'pages.system.menu.resource.form.method.placeholder': 'Please select the request method',
  'pages.system.menu.resource.form.path': 'Path',
  'pages.system.menu.resource.form.path.placeholder':
    'Please enter the request path (example: /api/admin/users/:id)',
  // role
  'pages.system.role.add': 'Add Role',
  'pages.system.role.edit': 'Edit Role',
  'pages.system.role.delTip': 'Are you sure you want to delete this role?',
  'pages.system.role.form.code': 'Code',
  'pages.system.role.form.code.placeholder': 'Please enter the code',
  'pages.system.role.form.code.required': 'Code is required!',
  'pages.system.role.form.name': 'Name',
  'pages.system.role.form.name.placeholder': 'Please enter the name',
  'pages.system.role.form.name.required': 'Name is required!',
  'pages.system.role.form.sequence': 'Sequence',
  'pages.system.role.form.status': 'Status',
  'pages.system.role.form.status.enabled': 'Enabled',
  'pages.system.role.form.status.disabled': 'Disabled',
  'pages.system.role.form.description': 'Description',
  'pages.system.role.form.created_at': 'Created At',
  'pages.system.role.form.updated_at': 'Updated At',
  'pages.system.role.form.basic': 'Basic Information',
  'pages.system.role.form.menu': 'Select Menu Permissions',
  'pages.system.role.form.menu.required': 'Please select at least one menu permission',
  // user
  'pages.system.user.add': 'Add User',
  'pages.system.user.edit': 'Edit User',
  'pages.system.user.delTip': 'Are you sure you want to delete this user?',
  'pages.system.user.form.username': 'Username',
  'pages.system.user.form.username.placeholder': 'Please enter the username',
  'pages.system.user.form.username.required': 'Username is required!',
  'pages.system.user.form.password': 'Password',
  'pages.system.user.form.password.placeholder': 'Use default password if empty',
  'pages.system.user.form.password.update.placeholder': 'Do not update password if empty',
  'pages.system.user.form.name': 'Name',
  'pages.system.user.form.name.placeholder': 'Please enter the name',
  'pages.system.user.form.name.required': 'Name is required!',
  'pages.system.user.form.email': 'Email',
  'pages.system.user.form.email.placeholder': 'Please enter the email',
  'pages.system.user.form.phone': 'Phone',
  'pages.system.user.form.phone.placeholder': 'Please enter the phone number',
  'pages.system.user.form.roles': 'Roles',
  'pages.system.user.form.roles.placeholder': 'Please select roles',
  'pages.system.user.form.roles.required': 'Please select at least one role',
  'pages.system.user.form.remark': 'Remark',
  'pages.system.user.form.status': 'Status',
  'pages.system.user.form.status.activated': 'Activated',
  'pages.system.user.form.status.freezed': 'Freezed',
  'pages.system.user.form.created_at': 'Created At',
  'pages.system.user.form.updated_at': 'Updated At',
  // logger
  'pages.system.logger.form.level': 'Level',
  'pages.system.logger.form.message': 'Message',
  'pages.system.logger.form.trace_id': 'Trace ID',
  'pages.system.logger.form.tag': 'Tag',
  'pages.system.logger.form.user_name': 'User Name',
  'pages.system.logger.form.created_at': 'Created At',
  // profile
  'pages.user.profile.tab.basic': 'Basic Information',
  'pages.user.profile.tab.security': 'Security Settings',
  'pages.user.profile.tab.security.form.old_password': 'Old Password',
  'pages.user.profile.tab.security.form.old_password.placeholder': 'Please enter your old password',
  'pages.user.profile.tab.security.form.old_password.required': 'Old password is required!',
  'pages.user.profile.tab.security.form.password': 'New Password',
  'pages.user.profile.tab.security.form.password.placeholder': 'Please enter your new password',
  'pages.user.profile.tab.security.form.password.required': 'New password is required!',
  'pages.user.profile.tab.security.form.confirm_password': 'Confirm Password',
  'pages.user.profile.tab.security.form.confirm_password.placeholder':
    'Please confirm your new password',
  'pages.user.profile.tab.security.form.confirm_password.required': 'Confirm password is required!',
  'pages.user.profile.tab.security.form.confirm_password.validator':
    'The two passwords that you entered do not match!',
};
